import request from '@/http/api'
// 外部设备专用接口
export const v1Api = {
  // 登录接口
  noTokenLogin: (params) => {
    return request.post('/sensor/oapi/noToken/login', params)
  },
  // 项目列表查询
  projectList: (params) => {
    return request.get('/sensor/oapi/project/list', params)
  },
  // 分组列表查询
  deviceGroupListByProjectId: () => {
    return request.get('/sensor/oapi/device-group/list/by-project-id')
  },
  // 新增分组
  createDeviceGroup: (params) => {
    return request.post('/sensor/oapi/device-group', params)
  },
  // 编辑分组
  updateDeviceGroup: (params) => {
    return request.put('/sensor/oapi/device-group', params)
  },
  // 删除分组
  delDeviceGroup: (params) => {
    return request.delete(`/sensor/oapi/device-group/${params}`)
  },
  // 根据目标id查询设备部件
  deviceComponentFindByTargetid: (params) => {
    return request.get(`/sensor/oapi/device-component/find-by-target-id/${params}`)
  },
  // 根据目标id查询设备部件详情
  deviceComponentFindDetailsByTargetId: (params) => {
    return request.get(`/sensor/oapi/device-component/find-details-by-target-id/${params}`)
  },
  // 新增部件
  createDeviceComponent: (params) => {
    return request.post(`/sensor/oapi/device-component`, params)
  },
  // 编辑部件
  updateDeviceComponent: (params) => {
    return request.put(`/sensor/oapi/device-component`, params)
  },
  // 删除部件
  delDeviceComponent: (params) => {
    return request.delete(`/sensor/oapi/device-component/${params}`)
  },
  // 温湿光数据记录
  deviceComponenDetailsThlChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/thl/chart`, params)
  },
  // 风速数据记录
  deviceComponentDetailsWindDpeedChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/wind-speed/chart`, params)
  },
  // 雨量数据记录
  deviceComponentDetailsRainfallChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/rainfall/chart`, params)
  },
  // 二氧化碳数据记录
  deviceComponentDetailsCo2Chart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/co2/chart`, params)
  },
  // 结构卫士数据记录
  deviceComponentDetailsGyroscopeChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/gyroscope/chart`, params)
  },
  // 气象百叶盒数据记录
  deviceComponentDetailsBYHChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/byh/chart`, params)
  },
  // 土壤数据记录
  deviceComponentDetailsEarthChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/earth/chart`, params)
  },
  // 综合面板数据
  chartPanelChartList: (params) => {
    return request.post(`/sensor/oapi/chart-panel/chart-list`, params)
  },
  // 新增项目
  createProject: (params) => {
    return request.post(`/sensor/oapi/project`, params)
  },
  // 编辑项目
  updateProject: (params) => {
    return request.put(`/sensor/oapi/project`, params)
  },
  deleteProject: (params) => {
    return request.delete(`/sensor/oapi/project/${params}`)
  },
  // 供电设备开关
  solarIotComponentDetailsCeviceDownsWwitchControl: (deviceId, switchState) => {
    return request.post(`/sensor/oapi/solar-iot-component-details/device-downs/switch-control/${deviceId}`, { switchState })
  },
  // 继电路开关控制
  componentTwoWayRelayDetailsWwitchControl: (params) => {
    return request.post(`/sensor/oapi/component-two-way-relay-details/switch-control`, params)
  },
  // 继电路开关控制全关
  componentTwoWayRelayDetailsWwitchControlCloseAll: (params) => {
    return request.post(`/sensor/oapi/component-two-way-relay-details/switch-control/close-all/${params}`)
  },
  // 继电路开关控制全开
  componentTwoWayRelayDetailsSwitchControlOpenAll: (params) => {
    return request.post(`/sensor/oapi/component-two-way-relay-details/switch-control/open-all/${params}`)
  },
  // 更新继电器
  componentTwoWayRelayDetailsUpdateStatus: (params) => {
    return request.post(`/sensor/oapi/component-two-way-relay-details/update-status/${params}`)
  },
  // 删除继电器
  deleteComponentTwoWayRelayDetails: (params) => {
    return request.delete(`/sensor/oapi/component-two-way-relay-details/${params}`)
  },
  // 继电器开关控制根据目标id查询
  thresholdRelayTargetId: (params) => {
    return request.get(`/sensor/oapi/threshold-relay/${params}`)
  },
  // 继电器新增编辑开关控制
  thresholdRelaySaveUpdate: (params) => {
    return request.post(`/sensor/oapi/threshold-relay/save-update`, params)
  },

  // 新增编辑两路继电器
  componentTwoWayRelayDetailsSaveUpdate: (params) => {
    return request.post(`/sensor/oapi/component-two-way-relay-details/save-update`, params)
  },
  // 光伏云更新
  solarIotComponentDetailsDeviceDownsGetStatus: (deviceId) => {
    return request.get(`/sensor/oapi/solar-iot-component-details/device-downs/get-status/${deviceId}`)
  },
  // 重置刷新光伏云设备数据
  solarIotComponentDetailsRetrieval: (id) => {
    return request.get(`/sensor/oapi/solar-iot-component-details/retrieval/${id}`)
  },
  // 光伏云查询数据统计
  solarIotComponentDetailsSolarMoteStatusHissGetList: (deviceId, params) => {
    return request.get(`/sensor/oapi/solar-iot-component-details/solar-mote-status-hiss/get-list/${deviceId}`, params)
  },
  // 光伏云查询历史充放电量,deviceId是指设备的moteId
  solarIotComponentDetailsSolarMoteStatusHissGetCharge: (deviceId, params) => {
    return request.get(`/sensor/oapi/solar-iot-component-details/solar-mote-status-hiss/get-charge/${deviceId}`, params)
  },
  // 光伏云查询历史供电时长,deviceId是指设备的moteId
  solarIotComponentDetailsSolarMoteStatusHissGetLightTime: (deviceId, params) => {
    return request.get(`/sensor/oapi/solar-iot-component-details/solar-mote-status-hiss/get-light-time/${deviceId}`, params)
  },
  // 获取萤石云token
  ezOpenGetToken: (params) => {
    return request.get(`/sensor/oapi/ez-open/get-token`, params)
  },
  // 更改用户昵称
  updateUser: (params) => {
    return request.put(`/sensor/oapi/user`, params)
  },
  // 修改用户密码
  updatePassword: (params) => {
    return request.post(`/sensor/oapi/user/update-password`, params)
  },
  findMonthWeather: (areaCode, month) => {
    return request.get(`t/wea_history/js/${month}/${areaCode}_${month}.js`)
  },
  // 分页查询用户
  userPage: (params) => {
    return request.post(`/sensor/oapi/user/page`, params)
  },
  // 新增用户
  creatUser: (params) => {
    return request.post(`/sensor/oapi/user`, params)
  },
  // 编辑用户
  updateUserInfo: (params) => {
    return request.put(`/sensor/oapi/user`, params)
  },
  // 删除用户
  deleteUser: (params) => {
    return request.post(`/sensor/oapi/user/delete`, params)
  },
  // 更该用户状态
  userUpdateState: (params) => {
    return request.post(`/sensor/oapi/user/update-state`, params)
  },
  // 重置密码
  userResetDefPassword: (params) => {
    return request.post(`/sensor/oapi/user/reset-def-password`, params)
  },
  // 根据用户ID查询角色
  roleUserId: (params) => {
    return request.get(`/sensor/oapi/role/user-id/${params}`)
  },
  // 查询当前用户可新增用户的下级角色
  roleCurrentUserLevelRole: () => {
    return request.get(`/sensor/oapi/role/current-user-level-role`)
  },

  // 项目用户查询
  projectAuthList: () => {
    return request.get(`/sensor/oapi/project-auth/list`)
  },
  // 删除项目用户
  deleteProjectAuth: (params) => {
    return request.delete(`/sensor/oapi/project-auth/${params}`)
  },
  // 新增项目用户
  createProjectAuth: (params) => {
    return request.post(`/sensor/oapi/project-auth`, params)
  },
  // 编辑用户项目
  updateProjectAuth: (params) => {
    return request.put(`/sensor/oapi/project-auth`, params)
  },
  // 分页查询供电告警
  powerComponentDetailsPage: (params) => {
    return request.post(`/sensor/oapi/power-component-details/page`, params)
  },
  // 推送列表查询
  msgUserList: (params) => {
    return request.get(`/sensor/oapi/msg-user/list`, params)
  },
  // 删除推送人员
  delMsgUser: (params) => {
    return request.delete(`/sensor/oapi/msg-user/${params}`)
  },
  // 新增推送人员
  addMsgUser: (params) => {
    return request.post(`/sensor/oapi/msg-user`, params)
  },
  // 查询全部用户，不包括查询超级管理员，提供给添加协作管理员接口使用
  userFindListProjectAuth: (params) => {
    return request.post(`/sensor/oapi/user/find-list-project-auth`, params)
  }
}
// 智芯云相关接口
export const zxyApi = {
  // 获取设备485BMS信息-查询数据库，如果没有数据会注册轮训
  getBmsInfoDb: (sn) => {
    return request.get(`/zxy/solar/base-bms-record/find-last-by-sn-chao-ben-le/${sn}`)
  },
  // 获取设备485BMS信息-查询设备
  getBmsInfoMote: (sn) => {
    return request.get(`/zxy/solar/base-bms-record/load-last-by-sn-chao-ben-le/${sn}`)
  },
  // 获取设备485BMS历史信息-查询设备
  getBmsInfoHistory: (options) => {
    return request.post(`/zxy/solar/base-bms-record/statistics-data`, {
      snHex: options.snHex,
      dateTimeSingle: options.dateTimeSingle
    })
  },
  // 导出BMS记录
  getBmsInfoExcel: (options) => {
    return request.postBlob(`/zxy/solar/base-bms-record/export-record`, {
      sn: options.sn,
      dateTime: options.dateTime
    })
  }
}

// 结构卫士相关接口
export const structApi = {
  // 根据SN获取结构卫士设备最新上报的记录
  structInfoBySn: (sn) => {
    return request.get(`/sensor/oapi/structural-device/getDeviceLastReport?sn=${sn}`)
  },
  // 获取结构卫士的报表
  gyroscopeChart: (params) => {
    return request.post(`/sensor/oapi/device-component-details/gyroscope/chart`, params)
  },
  // 获取最新的5条记录
  listLastRecord: (sn, coordinate) => {
    return request.get(`/sensor/oapi/structural-gyroscope/listLastRecord?sn=${sn}&coordinate=${coordinate}`)
  },
  // 获取阿里云token
  getUploadToken: () => {
    return request.get(`/sensor/oapi/aliyun/getUploadToken`)
  },
  // 获取设备参数
  getBashParam: (sn) => {
    return request.get(`/sensor/oapi/structural-device/getBashParam?sn=${sn}`)
  },
  // 修改设备参数
  setBashParam: (param) => {
    return request.post(`/sensor/oapi/structural-device/setBashParam`, param)
  },
  // 更新告警列表
  structuralAlarmUpdate: (param) => {
    return request.post(`/sensor/oapi/structural-alarm/update`, param)
  },
  // 获取sn号的告警列表
  structuralAlarmList: (sn) => {
    return request.get(`/sensor/oapi/structural-alarm/list?sn=${sn}`)
  },
  // 获取设备的告警值
  structuralAlarmSave: (param) => {
    return request.post(`/sensor/oapi/structural-alarm/save`, param)
  },
  // 清零
  structuralDeviceResetting: (param) => {
    return request.post(`/sensor/oapi/structural-device/resetting`, param)
  },
  // 更新设备值
  structuralDeviceUpdate: (sn) => {
    return request.post(`/sensor/oapi/structural-device/update`, {
      sn
    })
  },
  // 更新设备值
  structuralAlarmPagi: (projectId, pageNo = 1, beginDate, endDate, sn = '') => {
    let url = `/sensor/oapi/structural-alarm/pagi?projectId=${projectId}&pageNo=${pageNo}&pageSize=10&beginDate=${beginDate}&endDate=${endDate}&sn=${sn}`
    if (sn === '') {
      url = `/sensor/oapi/structural-alarm/pagi?projectId=${projectId}&pageNo=${pageNo}&pageSize=10&beginDate=${beginDate}&endDate=${endDate}`
    }
    return request.get(url)
  },
  // 导出报表
  structuralResultExport: (projectId, startTime, endTime, minute) => {
    let url = `/sensor/oapi/structural-positive-result/export?projectId=${projectId}&startTime=${startTime}&endTime=${endTime}&minute=${minute}:00`
    return request.getBlob(url)
  }
}
